import { Box, Typography } from "@mui/material";

const Unauthorized = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
        flexDirection: "column",
      }}
    >
      <Typography variant="h4" sx={{ mb: 2 }}>
        403 - Unauthorized
      </Typography>
      <Typography variant="body1">
        You don't have permission to access this page.
      </Typography>
    </Box>
  );
};

export default Unauthorized;